import Swiper from 'swiper/bundle';

if ($(".slider-downloads.swiper-container").length > 0) {
    const slider_type_downloads_swiper = new Swiper(".slider-downloads.swiper-container", {
        slidesPerView: 'auto',
        loop: true,
        speed: 1000,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: ".section-slider-downloads .swiper-button-next.slider-downloads-swiper-button",
            prevEl: ".section-slider-downloads .swiper-button-prev.slider-downloads-swiper-button",
        }
    });
}